export enum ChartType {
    doughnut = 1,
    bar,
    horizontalBar,
    line
}
